module.exports = ".content{display:flex;flex-direction:column;max-height:70vh;overflow:auto}\n"